module.exports = __webpack_public_path__ + "static/media/proyecto.121936d0.jpg";